import React, { useState, useEffect } from 'react';
import moment from 'moment';
import { DayPickerRangeController } from 'react-dates';
import isInclusivelyAfterDay from 'react-dates/esm/utils/isInclusivelyAfterDay';
import { RightCircleFilled, LeftCircleFilled } from '@ant-design/icons';

import Modal from 'components/UI/Antd/Modal/Modal';

import useWindowSize from 'library/hooks/useWindowSize';

import Wrapper, { NavButton } from './DatePickerDialog.style';


const DatePickerDialog = ({
  closePicker,
  openConfirm,
  datePickerOpened,
  newStartDate,
  setNewStartDate,
  newEndDate,
  setNewEndDate,
  reservationEndDate
}) => {
  const { width } = useWindowSize();
  const isMobile = width <= 991;

  const [ focusedInput, setFocusedInput ] = useState('startDate');

  const [ startDateSelected, setStartDateSelected ] = useState(false);
  const [ endDateSelected, setEndDateSelected ] = useState(false);

  const onDatesChange = ({ startDate, endDate }) => {
    setNewStartDate(startDate);
    setNewEndDate(endDate);
  };

  useEffect(() => {
    if(moment.isMoment(newStartDate)) {
      setStartDateSelected(true);
    }
  }, [newStartDate]);

  useEffect(() => {
    if(moment.isMoment(newEndDate)) {
      setEndDateSelected(true);
    }
  }, [newEndDate]);

  useEffect(() => {
    if(startDateSelected && endDateSelected) {
      closePicker();
      openConfirm();
    }
  }, [startDateSelected, endDateSelected]);

  useEffect(() => {
    if(!datePickerOpened) {
      setStartDateSelected(false);
      setEndDateSelected(false);
    }
  }, [datePickerOpened]);

  const onFocusChange = focusedInput => {
    setFocusedInput(!focusedInput ? 'startDate' : focusedInput);
  };

  return (
    <Modal
      visible={datePickerOpened}
      maxWidth='md'
      width={isMobile ? 326 : 745 }
      title={null}
      closable={false}
      bodyStyle={{ padding: '0px' }}
      centered={true}
      onCancel={closePicker}
      footer={null}
      zIndex={10001}
    >
      <Wrapper>
        <DayPickerRangeController
          numberOfMonths={ isMobile ? 1 : 2 }
          onFocusChange={ onFocusChange }
          focusedInput={ focusedInput }
          startDate={ newStartDate ? moment(newStartDate, 'YYYY-MM-DD') : null }
          endDate={ newEndDate ? moment(newEndDate, 'YYYY-MM-DD') : null  }
          onDatesChange={ onDatesChange }
          onOutsideClick={ closePicker }
          hideKeyboardShortcutsPanel
          daySize={isMobile ? 40 : 48}
          weekDayFormat='ddd'
          dayPickerNavigationInlineStyles={'background: red;'}
          noBorder
          customArrowIcon={<span style={{ padding: '0px 4px' }} />}
          renderNavNextButton={({ onClick }) => (
            <NavButton onClick={onClick}>
              <RightCircleFilled />
            </NavButton>
          )}
          renderNavPrevButton={({ onClick }) => (
            <NavButton onClick={onClick}>
              <LeftCircleFilled />
            </NavButton>
          )}
          isOutsideRange={ day => !isInclusivelyAfterDay(day, moment())
            || isInclusivelyAfterDay(
              day,
              moment(reservationEndDate.format('YYYY-MM-DD')).add(21, 'days')
            )
          }
        />
      </Wrapper>
    </Modal>
  );
};

export default DatePickerDialog;
